import createAPI from "../request";

const authOrign = () =>
  (localStorage.getItem("config")
    ? JSON.parse(localStorage.getItem("config"))
    : null
  )?.iamUrl;
const smartOrigin = () =>
  (localStorage.getItem("config")
    ? JSON.parse(localStorage.getItem("config"))
    : null
  )?.scConsoleUrl;
const candenceOrigin = () =>
  (localStorage.getItem("config")
    ? JSON.parse(localStorage.getItem("config"))
    : null
  )?.candenceUrl;

const domainAPI = {
  // 获取运行配置参数
  getAPIConfig: () =>
    createAPI(
      process.env.NODE_ENV === "development"
        ? "/assets/api.dev.json"
        : "/assets/api.json",
      "get"
    ),
  // 获取用户登录信息
  authLogin: (params) =>
    createAPI(`${authOrign()}/api/iam/v2/identity/login`, "post", params),
  /** 取得服務雲用戶的salt值 */
  getUserSaltHttp: (userId) =>
    createAPI(`${authOrign()}/api/iam/v2/user/salt`, "post", { id: userId }),

  /** 獲取rsa公鑰 */
  getIdentityPublickey: () =>
    createAPI(`${authOrign()}/api/iam/v2/identity/publickey`, "get"),

  /** * 獲取加密後的aes的key值 * */
  getIdentityAeskey: (publicKey) =>
    createAPI(`${authOrign()}/api/iam/v2/identity/aeskey`, "post", {
      clientEncryptPublicKey: publicKey,
    }),

  analyzeToken: () =>
    createAPI(`${authOrign()}/api/iam/v2/identity/token/analyze`, "post", {}),
  /** * 獲取租户list * */
  getTenantList: () =>
    createAPI(`${authOrign()}/api/iam/v2/tenant?appId=Athena`, "post", {}),

  /** * 切换租户 * */
  tokenRefreshTenant: (params) =>
    createAPI(
      `${authOrign()}/api/iam/v2/identity/token/refresh/tenant`,
      "post",
      params
    ),

  // 获取domain 信息
  getDomainInfo: () =>
    createAPI(
      `${smartOrigin()}/restful/standard/scconsole/domain/detail`,
      "post",
      { name: "athena" }
    ),

  // 新增
  getWorkflows: (params) =>
    createAPI(
      `${smartOrigin()}/restful/standard/scconsole/instance/pageQuery`,
      "post",
      params
    ),

  // 根据runId 查询 环节讯息
  getWorkflowRunInfoByRunId: (wid, rid) =>
    createAPI(
      `${smartOrigin()}/restful/standard/scconsole/instance/detail`,
      "post",
      { domain: "athena", wid, rid }
    ),
  // 中止workflow
  teminateWorkflow: (wid, rid, reason) =>
    createAPI(
      `${smartOrigin()}/restful/standard/scconsole/instance/terminate`,
      "post",
      { domain: "athena", wid, rid, reason }
    ),

  // 查询环节历史讯息
  getRunHistoryInfo: (wid, rid) =>
    createAPI(
      `${smartOrigin()}/restful/standard/scconsole/instance/history`,
      "post",
      { domain: "athena", waitForNewEvent: true, wid, rid }
    ),

  // 查询json中转义符变量值
  getEscapeValue: (param) =>
    createAPI(
      `${smartOrigin()}/restful/standard/scconsole/largeObject/detail`,
      "post",
      param
    ),

  // 获取domain下的 tasklist 的 Pollers
  getPollersInDomainByName: (domain, taskList) =>
    createAPI(
      `${smartOrigin()}/restful/standard/scconsole/taskList/pollers`,
      "post",
      { taskList, domain }
    ),

  // 下载runId 的 json 文件
  exportJsonFile: (domain, workflowId, runId) =>
    createAPI(
      `${candenceOrigin()}/api/domains/${domain}/workflows/${workflowId}/${runId}/export`,
      "get"
    ),

  // 获取电话簿列表
  getSelList: (params) =>
    createAPI("/TelephoneDirectory/selList", "post", params),
  // 获取分组列表
  getGroupList: (params) =>
    createAPI("/GroupController/selNameList", "get", params),
  // 删除联系人
  delPhone: (params) =>
    createAPI("/TelephoneDirectory/delPhone", "delete", params),
};

export default domainAPI;
